import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// Deliberately createRoot, not hydrateRoot, even though scripts/prerender.mjs
// ships real markup in #root. The prerender exists for crawlers, which read the
// HTML directly, so hydration would buy users only a marginal paint win while
// introducing mismatch risk: useTheme resolves to 'dark' on the server but reads
// localStorage in the browser, and dates format against the build machine's
// locale. React discards the server markup and renders fresh instead, which is
// the boring, correct-by-construction option. Revisit only if the paint matters.
const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
